module.exports = __webpack_public_path__ + "img/logo.363d43d3.png";